// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241853/js/" + chunkId + "." + {"44":"a4e5404d","225":"0be2ca5a","481":"d8128c74","486":"4cb33a1e","770":"0f3aec8e"}[chunkId] + ".0.626190746766255.chunk.js";
};